<div #looker class="w-full h-full charts flex dark:bg-kohort-secondary bg-white"></div>
<div
  class="absolute top-0 bottom-0 left-0 right-0 inset-0 z-10 flex flex-col items-center justify-center text-gray-300 dark:text-slate-800 transition-all dark:bg-background bg-white"
  [ngClass]="{
    'opacity-0 pointer-events-none': !loading()
  }">
  <div class="flex items-center justify-center p-20 relative">
    <div class="absolute inset-0 flex items-center justify-center">
      <app-svg-images svgName="spinner" class="h-24 w-24"></app-svg-images>
    </div>
    <div>
      <img src="/assets/images/logo-small-dark.png" class="h-5 dark:hidden">
      <img src="/assets/images/logo-small.png" class="h-5 hidden dark:block">
    </div>
  </div>
</div>

